<template>
  <div class="p-8">
    <div>
      <div class="flex justify-between">
        <h2 class="font-semibold uppercase text-gray-600">SOS LIST</h2>
      </div>

      <div class="flex justify-between">
        <div class="relative max-w-sm w-full">
          <div class="absolute inset-y-0 flex items-center px-3">
            <i class="material-icons text-gray-500">search</i>
          </div>
          <input
            class="rounded border pl-10 pr-4 py-2 w-full"
            v-model="searchText"
            placeholder="Search"
            @keyup="search"
          />
          <ul
            v-if="drivers.length || passengers.length"
            class="absolute max-h-56 mt-1 bg-white border rounded shadow overflow-y-auto"
          >
            <li
              v-for="(result, index) in drivers"
              :key="`driver-${index}`"
              class="px-3 py-2 cursor-pointer hover:bg-blue-500 hover:text-white"
              @click="filterSos('driver', result)"
            >
              {{ result.firstName + " " + result.lastName }},
              {{ result.phoneNumber }}, Driver
            </li>

            <li
              v-for="(result, index) in passengers"
              :key="`passenger-${index}`"
              class="px-3 py-2 cursor-pointer hover:bg-blue-500 hover:text-white"
              @click="filterSos('passenger', result)"
            >
              {{ result.firstName + " " + result.lastName }},
              {{ result.phoneNumber }}, passenger
            </li>
          </ul>
        </div>

        <div class="w-48">
          <select class="form-select w-full" v-model="type" @change="getSos">
            <option :selected="type === 'all'" value="all">
              All
            </option>
            <option :selected="type === 'passenger'" value="passenger">
              Passenger
            </option>
            <option :selected="type === 'driver'" value="driver">
              Driver
            </option>
          </select>
        </div>
      </div>

      <div class="inline-block min-w-full shadow rounded-lg mt-4">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Driver Fullname
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Passanger Fullname
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Driver Phonenumber
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Passanger Phonenumber
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Type
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Happened AT
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              ></th>
            </tr>
          </thead>
          <tbody class v-if="allSos.length">
            <tr v-for="sos in allSos" :key="sos._id">
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <router-link
                  :to="{ path: '/drivers/' + sos.driver._id }"
                  class="whitespace-no-wrap"
                  >{{
                    sos.driver.firstName + " " + sos.driver.lastName || "__"
                  }}</router-link
                >
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{
                    sos.passenger.firstName + " " + sos.passenger.lastName ||
                      "__"
                  }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ sos.driver.phoneNumber || "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ sos.passenger.phoneNumber || "-" }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ sos.type || "-" }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ formatDate(sos.createdAt) }}
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p v-if="sos.ride" class="text-gray-900 whitespace-no-wrap">
                  <a :href="'/rides/' + sos.ride + '/show'" target="self"
                    ><i class="material-icons mr-2">visibility</i></a
                  >
                </p>
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                class="bg-white py-4 text-center text-gray-600 font-semibold"
              >
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No SOS History found!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex justify-between items-end">
        <p class="text-gray-600">
          Showing
          <strong>{{ start }}</strong> to <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select
              class="form-select"
              name="perPage"
              id="perPage"
              @change="setPerPage"
            >
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/mixins/Pagination";
import moment from "moment";

export default {
  mixins: [Pagination],
  data() {
    return {
      allSos: [],
      openDropdown: false,
      loading: true,
      drivers: [],
      passengers: [],
      passengerId: "",
      driverId: "",
      searchText: "",
      type: "all"
    };
  },
  created() {
    this.getSos();
  },
  watch: {
    currentPage() {
      this.getSos();
    },
    perPage() {
      this.getSos();
    }
  },
  computed: {
    riders() {
      return this.results.length ? this.results : this.allSos;
    }
  },
  methods: {
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    getSos() {
      this.loading = true;
      var path = `/sos?limit=${this.perPage}&page=${this.currentPage}&populate=["driver","passenger","vehicle"]`;

      if (this.passengerId) {
        path += "&passenger=" + this.passengerId;
      }

      if (this.type && this.type != "all") {
        path += "&type=" + this.type;
      }

      if (this.driverId) {
        path += "&driver=" + this.driverId;
      }

      this.$http
        .get(path)
        .then(response => {
          this.allSos = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    filterSos(type, data) {
      this.passengerId = "";
      this.driverId = "";
      this.drivers = [];
      this.passengers = [];

      if (type == "passenger") {
        this.passengerId = data._id;
        this.searchText =
          data.firstName +
          " " +
          data.lastName +
          ", " +
          data.phoneNumber +
          ", " +
          type;
      } else if (type == "driver") {
        this.driverId = data._id;
        this.searchText =
          data.firstName +
          " " +
          data.lastName +
          ", " +
          data.phoneNumber +
          ", " +
          type;
      }

      this.getSos();
    },
    search: _.debounce(function(e) {
      if (!e.target.value.trim()) {
        this.results = [];
        this.drivers = [];
        this.passengers = [];
        this.driverId = "";
        this.passengerId = "";
        this.getSos();
        return;
      }

      this.$http
        .get(`/drivers/search?limit=5&q=${e.target.value}`)
        .then(response => {
          this.drivers = response.data;
        })
        .catch(err => console.log(err));

      this.$http
        .get(`/users/search?limit=5&q=${e.target.value}`)
        .then(response => {
          this.passengers = response.data;
        })
        .catch(err => console.log(err));
    }, 500),
    remove(index) {
      //   this.$http
      //     .delete(`/riders/${this.riders[index]._id}`)
      //     .then(response => console.log(response))
      //     .catch(err => console.log(err));
      this.sos.splice(index, 1);
      this.openDropdown = false;
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY HH:mm");
    }
  }
};
</script>
